// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import styles from './Backstage.module.css'
import IconButton from '../IconButton/IconButton'
import type { LucideIcon } from 'lucide-react'

export interface DockApp {
    id: string
    name: string
    icon: LucideIcon
    action: () => void
}

export interface BackstageDockProps {
    apps: DockApp[]
    onSelect: (appId: string) => void
}

export function BackstageDock({ apps, onSelect }: BackstageDockProps): ReactElement {
    return (
        <div className={styles.collapsedBar}>
            {apps.map((app) => (
                <IconButton
                    key={app.id}
                    className={styles.collapsedApp}
                    onClick={() => { app.action(); onSelect(app.id) }}
                    aria-label={app.name}
                    title={app.name}
                >
                    <app.icon className={styles.collapsedAppIcon} />
                </IconButton>
            ))}
        </div>
    )
}

export default BackstageDock


